import { render, staticRenderFns } from "./WithdrawStepV2.vue?vue&type=template&id=5acc1086&scoped=true"
import script from "./WithdrawStepV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./WithdrawStepV2.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./WithdrawStepV2.vue?vue&type=style&index=0&id=5acc1086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acc1086",
  null
  
)

export default component.exports